import { render, staticRenderFns } from "./VxCard.vue?vue&type=template&id=fcac7dc2&"
import script from "./VxCard.vue?vue&type=script&lang=js&"
export * from "./VxCard.vue?vue&type=script&lang=js&"
import style0 from "./VxCard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports